import { useRef, useCallback } from 'react';
import useFetchDispatcher from './useFetchDispatcher.js';
/**
 * Build an imperative dispatcher to issue network requests.
 * @deprecated use https://resthooks.io/docs/api/Controller#fetch
 */

export default function useFetcher(fetchShape) {
  let throttle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const dispatchFetcher = useFetchDispatcher(throttle); // we just want the current values when we dispatch, so
  // box the shape in a ref to make react-hooks/exhaustive-deps happy

  const shapeRef = useRef(fetchShape);
  shapeRef.current = fetchShape;
  const fetchDispatcher = useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return dispatchFetcher(shapeRef.current, ...args);
  }, [dispatchFetcher]); // any is due to the ternary that we don't want to deal with in our implementation

  return fetchDispatcher;
}